import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { toSubscriber } from 'rxjs/internal-compatibility';
import { LocalStorageService } from '../../core/local-storage.service';
import { LanguageCodeEnum, UserRole } from '../enum/base.enum';


@Component({
  selector: 'app-language-translator',
  templateUrl: './language-translator.component.html',
  styleUrls: ['./language-translator.component.scss']
})
export class LanguageTranslatorComponent {
  showLoader : boolean;
  role : string;
  userRole = UserRole;
  languageCode: string = LanguageCodeEnum.US_English;
  constructor(public localStorageService: LocalStorageService) {
    const userDetail = this.localStorageService.getCurrentUserDetail();
    this.languageCode = (userDetail === null || userDetail.languagecode === null) ? this.languageCode : userDetail.languagecode;
    this.role = userDetail ? userDetail.role : '';
 
    this.localStorageService.setLanguage(this.languageCode);
  }
}
